import { createMarketing, createNotice, createPatent, createRecruit, deleteMarketingsInTransaction, deleteNoticesInTransaction, deletePatentsInTransaction, deleteRecruitsInTransaction, fetchMarketings, fetchNotices, fetchPatents, fetchRecruits, fetchTabManagers, updateMarketing, updateNotice, updatePatent, updateRecruit } from "../common/firebase/Firestore";
import { deleteAllFilesInFolder, deleteFileByPath, uploadFiles } from "../common/firebase/Storage";
import Marketing from "../model/board/Marketing";
import Notice from "../model/board/Notice";
import Patent from "../model/board/Patent";
import Recruit from "../model/board/Recruit";
import TabManager from "../model/board/TabManager";

/**
 * 채용 공고 리스트 조회 함수
 * @async
 * @function fetchCustomerInquiryList
 * @returns {Promise<CustomerInquiry[]>}
 */
const fetchRecruitList = async (): Promise<Recruit[]> => {
    return await fetchRecruits();
}

/**
 * 채용 공고 다건 삭제 요청 함수
 * @async
 * @function requestDeleteRecruitDocuments
 * @param {string[]} ids - document id 배열
 */
const requestDeleteRecruitDocuments = async (ids: string[]) => {
    await deleteRecruitsInTransaction(ids);
}

/**
 * 채용 공고 유형 조회 함수
 * @async
 * @function fetchRecruitType
 * @returns {Promise<TabManager[]>}
 */
const fetchRecruitType = async (): Promise<TabManager[]> => {
    return await fetchTabManagers("recruit");
}

/**
 * 채용 공고 생성 함수
 * @async
 * @function fetchRecruitType
 * @param {Recruit} recruit - 채용 공고 정보
 * @returns {Promise<string>}
 */
const requestCreateRecruitDocuments = async (recruit: Recruit): Promise<string> => {
    const recruitDocId = await createRecruit(recruit);
    return recruitDocId;
}

const requestUpdateRecruitDocuments = async (recruit: Recruit) => {
    await updateRecruit(recruit);
}

const requestUploadFiles = async (prefix: string, docId: string, type: string, files: File[]): Promise<string[]> => {
    return await uploadFiles(prefix, docId, type, files);
}

const requestDeleteFile = async (filePath: string) => {
    await deleteFileByPath(filePath);
}

const requestDeleteAllFiles = async (prefix: string, docId: string) => {
    await deleteAllFilesInFolder(prefix, docId);
}

const fetchPatentList = async (): Promise<Patent[]> => {
    return await fetchPatents();
}

/**
 * 특허 유형 조회 함수
 * @async
 * @function fetchPatentType
 * @returns {Promise<TabManager[]>}
 */
const fetchPatentType = async (): Promise<TabManager[]> => {
    return await fetchTabManagers("patent");
}

const requestDeletePatentDocuments = async (ids: string[]) => {
    await deletePatentsInTransaction(ids);
}

const requestCreatePatentDocuments = async (patent: Patent): Promise<string> => {
    const patentDocId = await createPatent(patent);
    return patentDocId;
}

const requestUpdatePatentDocuments = async (patent: Patent) => {
    await updatePatent(patent);
}

const fetchMarketingList = async (): Promise<Marketing[]> => {
    return await fetchMarketings();
}

/**
 * 홍보 유형 조회 함수
 * @async
 * @function fetchMarketingType
 * @returns {Promise<TabManager[]>}
 */
const fetchMarketingType = async (): Promise<TabManager[]> => {
    return await fetchTabManagers("marketing");
}

const requestDeleteMarketingDocuments = async (ids: string[]) => {
    await deleteMarketingsInTransaction(ids);
}

const requestCreateMarketingDocuments = async (marketing: Marketing): Promise<string> => {
    const marketingDocId = await createMarketing(marketing);
    return marketingDocId;
}

const requestUpdateMarketingDocuments = async (marketing: Marketing) => {
    await updateMarketing(marketing);
}

/**
 * 공지사항 리스트 조회 함수
 * @async
 * @function fetchNoticeList
 * @returns {Promise<Notice[]>}
 */
const fetchNoticeList = async (): Promise<Notice[]> => {
  return await fetchNotices();
};

/**
 * 공지사항 다건 삭제 요청 함수
 * @async
 * @function requestDeleteNoticeDocuments
 * @param {string[]} ids - document id 배열
 */
const requestDeleteNoticeDocuments = async (ids: string[]) => {
  await deleteNoticesInTransaction(ids);
};

/**
 * 공지사항 생성 함수
 * @async
 * @function requestCreateNoticeDocuments
 * @param {Notice} notice - 공지사항 정보
 * @returns {Promise<string>}
 */
const requestCreateNoticeDocuments = async (
  notice: Notice
): Promise<string> => {
  const noticeDocId = await createNotice(notice);
  return noticeDocId;
};

/**
 * 공지사항 수정 함수
 * @async
 * @function requestUpdateNoticeDocuments
 * @param {Notice} notice - 공지사항 정보
 */
const requestUpdateNoticeDocuments = async (notice: Notice) => {
  await updateNotice(notice);
};

export {
    fetchRecruitList, requestDeleteRecruitDocuments, fetchRecruitType, requestCreateRecruitDocuments, requestUpdateRecruitDocuments,
    requestUploadFiles, requestDeleteFile, requestDeleteAllFiles,
    fetchPatentList, fetchPatentType, requestDeletePatentDocuments, requestCreatePatentDocuments, requestUpdatePatentDocuments,
    fetchMarketingList, fetchMarketingType, requestDeleteMarketingDocuments, requestCreateMarketingDocuments, requestUpdateMarketingDocuments,
    fetchNoticeList, requestDeleteNoticeDocuments, requestCreateNoticeDocuments, requestUpdateNoticeDocuments
};